import { Component , OnInit} from '@angular/core';
import { CarouselComponent } from '../carousel/carousel.component';
import { DrawerComponent } from '../drawer/drawer.component';
import { CommonModule } from '@angular/common';
import { SignatureComponent } from "../signature/signature.component";

@Component({
  selector: 'app-home',
  imports: [CarouselComponent, DrawerComponent, CommonModule, SignatureComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  standalone: true
})
export class HomeComponent implements OnInit {

  menus = [
    { name: 'Pizza', image: 'assets/images/main1.jpeg', description: 'Delicious cheese pizza' },
    { name: 'Burger', image: 'assets/images/main2.jpeg', description: 'Juicy beef burger' },
    { name: 'Pasta', image: 'assets/images/main3.jpeg', description: 'Italian pasta with marinara sauce' }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}